<template>

    <div class="room-availability">

        <div class="mb-4">
            <booking-summary v-bind:highlight="true"></booking-summary>
        </div>

        <div class="container-fluid container-xl">

            <div v-if="isLoading" class="mt-5 d-flex justify-content-center">
                <loader></loader>
            </div>

            <div v-if="!isLoading">
                <div class="mb-4">

                    <current-action v-bind:roomIndex="leg"
                                    v-bind:action="'Select Room'"></current-action>

                </div>

                <div v-if="requiresDogButNone">

                    <info-box v-bind:type="'error'">
                        <template v-slot:body>
                            <span class="heading">
                                Dogs

                            </span>

                            <div>
                                <p>

                                    Unfortunately there are no dog friendly rooms available for your selected dates.
                                    <router-link v-bind:to="{name : 'stay_search', params: {id: this.session.Id}}">
                                        <strong>Try a new date</strong>
                                    </router-link>
                                    or continue without a dog-friendly room below.
                                </p>
                            </div>
                        </template>
                    </info-box>
                </div>

                <div v-if="roomConfiguration">
                    <room-category-panel v-for="aa in availableAreas"
                                         v-bind:key="aa.area.Key"
                                         v-bind:leg="leg"
                                         v-bind:requiresDogButNone="requiresDogButNone"
                                         v-bind:a="aa"></room-category-panel>

                </div>
            </div>
        </div>
    </div>



    <calendar-modal v-if="showCalendar" v-bind:hasError="hasError">
        <template v-slot:logo>

        </template>
        <template v-slot:header>

        </template>
        <template v-slot:body>

        </template>
    </calendar-modal>


</template>

<script>
    import { _ } from 'vue-underscore';

    import BookingSummary from '../components/BookingSummary.vue';
    import CurrentAction from '../components/CurrentAction.vue';
    import RoomCategoryPanel from '../components/RoomCategoryPanel.vue';
    import CalendarModal from '../components/CalendarModal.vue';

    import Loader from '@/shared/components/Loader.vue';
    import InfoBox from '@/shared/components/InfoBox.vue';

    import { store } from '../store/index';

    export default {
        name: 'RoomAvailability',
        components: {
            BookingSummary,
            CurrentAction,
            RoomCategoryPanel,
            CalendarModal,
            Loader,
            InfoBox
        },
        mounted() {
            this.trackRoomAvailability();
            store.dispatch('searchRooms', this.search);
        },
        data() {
            return {
                hasError: false
            }
        },
        methods: {

            trackRoomAvailability() {

                if (this.$gtm.enabled()) {

                    let items = [];

                    for (let i = 0; i < this.areas.length; i++) {
                        let main = this.areas[i];

                        for (let y = 0; y < main.RoomTypes.length; y++) {
                            let details = main.RoomTypes[y];
                            let item = {
                                'item_id': details.PMSCode,
                                'item_name': details.DisplayName,
                                'item_list_name': main.DisplayName,
                            };
                            items.push(item);
                        }

                    }

                    window.dataLayer?.push({
                        'pageURL': '/stay/room/' + this.leg,
                        'event': 'view_item_list',
                        'ecommerce': {
                            'item_list_name': 'Room Availability',
                            'items': items
                        }
                    });
                }


            },

        },

        computed: {
            booking() {
                return store.getters.booking;
            },
            session() {
                return store.getters.session
            },
            roomOccupancy() {
                return this.search.guestOccupancies[+(this.leg) - 1];
            },

            search() {
                return store.getters.search;
            },
            leg() {
                return this.$route.params.leg;
            },
            roomConfiguration() {

                return store.getters.roomConfiguration;
            },
            areas() {
                let roomConfiguration = this.roomConfiguration;
                return roomConfiguration.Areas;
            },
            stayAvailability() {
                return store.getters.stayAvailability;
            },
            requiresDogButNone() {
                let result = false;

                if (this.roomOccupancy.dogs > 0) {
                    result = true;


                    for (let ai in this.areas) {
                        let area = this.areas[ai];
                        for (let ri in area.RoomTypes) {

                            let roomType = area.RoomTypes[ri];

                            if (!roomType.IsDogFriendly) {
                                continue;
                            }

                            let roomAvailability = store.getters.roomAvailability(this.leg, roomType.PMSCode);

                            if (roomAvailability != undefined && roomAvailability.Packages != null && roomAvailability.Packages !== undefined && roomAvailability.Packages != null) {

                                let dogPackage = roomAvailability.Packages.find(item => item.Code == "DOG");
                                if (dogPackage != null) {
                                    if (roomAvailability != undefined && roomAvailability != null && roomAvailability.Room.UnitsAvailable > 0 && roomAvailability.Packages) {

                                        if (dogPackage.IsAvailable) {
                                            return false;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }


                return result;
            },
            availableAreas() {
       
                let result = [];
                let o = this;
                for (let ai in this.areas) {

                    let area = this.areas[ai];
                    let areaRooms = [];

                    for (let ri in area.RoomTypes) {
                        let roomType = area.RoomTypes[ri];
                        let roomAvailability = store.getters.roomAvailability(this.leg, roomType.PMSCode);

                        areaRooms.push({
                            roomType,
                            roomAvailability
                        });

                    }


                    var chainResult = _.sortBy(areaRooms, function (item) {
                        let amount = 0;
                        let units = 0;
                        if (item.roomAvailability != undefined && item.roomAvailability != null) {
                            units = item.roomAvailability.Room.UnitsAvailable;

                            if (units == 0 || (o.roomOccupancy.dogs > 0 && !item.roomType.IsDogFriendly)) {
                                amount = Number.MAX_SAFE_INTEGER;
                            }
                            else {
                                let ratea = item.roomAvailability.Rates.find(item => item.RateCode == "DAILYBABB");
                                if (ratea == undefined || ratea == null) {
                                    let sorted = item.roomAvailability.Rates.sort(function (a, b) { return a.Amount - b.Amount; });
                                    ratea = sorted[0];

                                }
                                amount = ratea.Amount;
                            }
                        } else {
                            amount = Number.MAX_SAFE_INTEGER;
                        }

                        return amount;
                    });

                    areaRooms = chainResult;

                    let ia = {
                        area,
                        areaRooms
                    }

                    result.push(ia);

                }

          
                if (this.roomOccupancy.children != null && this.roomOccupancy.children.length)
                {
                    result = _.sortBy(result, function (item) {

                        let rooms = item.areaRooms.filter(i => i.roomType.IsChildFriendly);

                        if (rooms != null && rooms.length) {
                            return rooms.filter(item => item.roomAvailability != undefined && item.roomAvailability.Room.UnitsAvailable > 0).length;
                        }

                        return -1;

                    });
                }

                else if (this.roomOccupancy.dogs > 0) {

                    result = _.sortBy(result, function (item) {

                        let rooms = item.areaRooms.filter(i => i.roomType.IsDogFriendly);

                        if (rooms != null && rooms.length) {
                            return rooms.filter(item => item.roomAvailability != undefined && item.roomAvailability.Room.UnitsAvailable > 0).length;
                        }

                        return -1;

                    });
                } else {

                    result.sort(function (a, b) {

                        let ai = a.areaRooms.map(item => {
                            if (item.roomAvailability != undefined) {
                                return item.roomAvailability.Room.UnitsAvailable;
                            }
                            return 0;
                        });
                        let bi = b.areaRooms.map(item => {
                            if (item.roomAvailability != undefined) {
                                return item.roomAvailability.Room.UnitsAvailable;
                            }
                            return 0;
                        });

                        let totalRoomsA = ai.reduce((l, r) => l + r);
                        let totalRoomsB = bi.reduce((l, r) => l + r);

                        if (totalRoomsA < totalRoomsB) {
                            return -1;
                        }
                        if (totalRoomsA > totalRoomsB) {
                            return 1;
                        }


                        return 0;
                    })
                }

                return result.reverse();

            },




            showCalendar() {

                if (this.stayAvailability != null) {
           
                    if (this.stayAvailability.IsPromoAvailable != null) {
            
                        return !this.stayAvailability.IsPromoAvailable
                    }

                    this.hasError = this.stayAvailability.HasError;
                    return !this.stayAvailability.IsAvailable;


                }

                this.hasError = false;
   



                return false;
            },

            isLoading() {
                return this.stayAvailability == null;
            },
        }

    }
</script>

<style src="@/modules/stay/css/room-availability.css"></style>